import { render } from "./TabCards.vue?vue&type=template&id=3431c54c"
import script from "./TabCards.vue?vue&type=script&lang=js"
export * from "./TabCards.vue?vue&type=script&lang=js"

import "./TabCards.vue?vue&type=style&index=0&id=3431c54c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__